<template>
  <div class="calendar-container">
    <v-date-picker
      full-width
      v-model="date1"
      :events="allowedDates"
      :allowed-dates="allowedDates"
      event-color="#f68b23"
      header-color="#238ef6"
    ></v-date-picker>
    <div class="input-time">
      <div>
        <br />
        <h1>Select hour</h1>
        <div class="input-clock">
          <v-select
            v-model="hour"
            :dense="true"
            color="#033"
            :items="hours"
            placeholder="00"
            outlined
          ></v-select>
          <h1>:</h1>
          <v-select
            v-model="minute"
            :dense="true"
            color="#033"
            :items="minutes"
            placeholder="00"
            outlined
          ></v-select>
        </div>
      </div>
      <div>
        <br />
        <h1>Duration</h1>
        <div class="input-clock" style="width: 112px">
          <v-select
            v-model="duration"
            :dense="true"
            color="#033"
            :items="[1, 2]"
            placeholder="00"
            outlined
          ></v-select>
          <h1>Hrs</h1>
        </div>
      </div>
    </div>
    <div class="input-time">
      <h2>Select date and time according convenience</h2>
    </div>
    <button class="calendar-btn" @click="close">Confirm</button>
    <ModalVue
      v-if="modal"
      Titulo="Success"
      Texto="Scheduled meeting"
      Color="background: var(--firts-color);"
      @Aceptar="Aceptar"
    />
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import ModalVue from "./Modal.vue";
export default {
  props: {
    info: {
      type: Object,
      requiered: true,
    },
  },
  components: {
    ModalVue,
  },
  data: () => ({
    arrayEvents: null,
    date1: new Date().toISOString().substr(0, 10),
    hours: [
      "08",
      "09",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
    ],
    minutes: ["00", "15", "30", "45"],
    hour: "",
    minute: "",
    duration: "",
    modal: false,
  }),
  methods: {
    ...mapMutations("CalendarEvents", ["mtaAddEvent"]),
    functionEvents(date) {
      const [, , day] = date.split("-");
      if ([12, 17, 28].includes(parseInt(day, 10))) return true;
      return false;
    },
    allowedDates: (val) => parseInt(val.split("-")[2], 10) % 2 === 0,
    close() {
      if (this.date1 && this.hour && this.minute) {
        const ArrayOfDate = this.date1.split("-");
        var mes = ArrayOfDate[1];
        var auxMonth = parseInt(mes) - 1;
        var newMonth = auxMonth.length == 2 ? `${auxMonth}` : `0${auxMonth}`;
        let start = new Date(
          ArrayOfDate[0],
          newMonth,
          ArrayOfDate[2],
          this.hour,
          this.minute,
          "00"
        );
        let end = new Date(start);
        end.setHours(end.getHours() + this.duration);
        const event = {
          name: "Meeting",
          start,
          end,
          consultant: this.info.Name,
          phase: "6",
          process: "6.2",
        };

        this.mtaAddEvent(event);
        this.modal = true;
      }
    },
    Aceptar() {
      this.modal = false;
      this.$emit("close", "Interaction");
    },
  },
  mounted() {
    this.arrayEvents = [...Array(14)].map(() => {
      const day = Math.floor(Math.random() * 30);
      const d = new Date();
      d.setDate(day);
      return d.toISOString().substr(0, 10);
    });
  },
};
</script>

<style lang="css" scoped>
.calendar-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  background: white;
}
.input-clock {
  width: 150px;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  font-family: "Montserrat", sans-serif !important;
  font-weight: 400 !important;
}
.calendar-btn {
  background: var(--sixth-color);
  padding: 10px;
  margin: 10px;
  font-size: 1rem;
  color: white;
  font-weight: bold;
  border-radius: 10px;
  text-transform: uppercase;
}
.input-time {
  width: 100%;
  display: flex;
  justify-content: space-between;
  color: var(--nineth-color) !important;
  font-size: 0.7rem !important;
  padding: 0 10px;
  font-family: "Montserrat", sans-serif;
  font-weight: bold;
}
</style>